/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit PastDue.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import InfoBadgeInline from 'DesignSystem/InfoBadgeInline/view.js'
import React from 'react'



export default function PastDue({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Members/ListItems/SubscriptionStatus/PastDue"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<InfoBadgeInline
 data-testid="PastDue.InfoBadgeInline"
 data-view-path="/App/MyAccount/Content/Members/ListItems/SubscriptionStatus/PastDue"
viewPath={`${viewPath}/InfoBadgeInline`}
 text="Past Due"
 height={20}
 marginLeft={0}
 backgroundColor="rgba(252,234,234, 1)"
 color="rgba(224,51,51, 0.9)"
 borderColor="rgba(224,51,51, 0.4)"
/>
{children}
</React.Fragment>)
}